enum QuotaControlPermission {
  Prem_QuotaControl_View = 'Prem_QuotaControl_View',
  Prem_QuotaControl_Add = 'Prem_QuotaControl_Add',
  Prem_QuotaControl_Edit = 'Prem_QuotaControl_Edit',
  Prem_QuotaControl_Override = 'Prem_QuotaControl_Override',
}

export default QuotaControlPermission;
